import { FollowState } from '@/composition/follow'
import { UserState } from '@/composition/users'
import { useGlobalStore } from '@/store/app'
import { GAEventTypes, trackCustomGAEvents } from '@ghl/clientportal-core'

export async function handleFollowHelper(
  userId: string,
  isFollowing: boolean
): Promise<{ success: boolean; message: string }> {
  try {
    const appState = useGlobalStore()
    if (appState.isAuthenticated) {
      if (isFollowing) {
        await FollowState.unfollowUser(userId)
        return {
          success: true,
          message: 'globalUserProfile.unfollowSuccess',
        }
      } else {
        await FollowState.followUser(userId)
        return {
          success: true,
          message: 'globalUserProfile.followSuccess',
        }
      }
    } else {
      appState.openLoginModal()
      return {
        success: false,
        message: '',
      }
    }
  } catch (_) {
    console.error(_)
    return {
      success: false,
      message: 'common.somethingWentWrong',
    }
  } finally {
    sendFollowTrackingEvent(userId, isFollowing)
  }
}

function sendFollowTrackingEvent(
  followingUserId: string,
  isFollowing: boolean
) {
  trackCustomGAEvents(
    !isFollowing ? GAEventTypes.FOLLOW : GAEventTypes.UNFOLLOW,
    {
      userId: UserState.state.currentUser?.contactId,
      followingUserId,
      isFollowing,
    }
  )
}
